import { render, staticRenderFns } from "./ParagraphSimpleText.vue?vue&type=template&id=294d942e&"
import script from "./ParagraphSimpleText.vue?vue&type=script&lang=js&"
export * from "./ParagraphSimpleText.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphSimpleText.vue?vue&type=style&index=0&id=294d942e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports